import { useCallback } from "react";

import { useAccommodationHotelPolicyFormModelContext } from "../../../../../../../context";

export const useReservationLocalPaymentCancelFeeTransferLimitDays = () => {
	const { viewModel, onSetViewModel } = useAccommodationHotelPolicyFormModelContext();
	const { localPaymentCancelFeeTransferLimitDays } = viewModel;

	const isEdited = localPaymentCancelFeeTransferLimitDays.limitDays?.isEdited;
	const hasError = Boolean(localPaymentCancelFeeTransferLimitDays.limitDays?.error);

	const onSetLocalPaymentCancelFeeTransferLimitDays = useCallback(
		(input: number | undefined) => {
			onSetViewModel([
				{
					key: "localPaymentCancelFeeTransferLimitDays",
					value: {
						limitDays: {
							isEdited: true,
							value: input!, // Zodのバリデーションエラーを出すために 未入力（undefined）許容している
						},
					},
				},
			]);
		},
		[onSetViewModel],
	);

	return {
		isEdited,
		hasError,

		localPaymentCancelFeeTransferLimitDays,
		onSetLocalPaymentCancelFeeTransferLimitDays,
	};
};
